import type { DrilldownDotColor } from "./drilldown-card.types"

/**
 * Shared dup-badge derivation: show the raw count when there is more than one,
 * else hide the badge. Competitors passes `assets` (DrilldownCompetitorRow.Assets);
 * My Brand passes `creatives` — different source fields, same rule.
 */
export function resolveDupBadgeCount(count: number): number | null {
  return count > 1 ? count : null
}

/**
 * Narrows a My Brand KPI catalog entry's `colorVar` (typed as plain `string` in
 * MyBrandKpiCatalogEntry) into the DrilldownDotColor union. Every real catalog
 * entry is a `var(--chart-N)` token resolved from `colorToken` — this only trips
 * the "#464b67" fallback if that invariant is ever violated.
 */
export function asDrilldownDotColor(colorVar: string): DrilldownDotColor {
  return colorVar.startsWith("var(--") ? (colorVar as DrilldownDotColor) : "#464b67"
}
